// Types

// Services
import { gql } from 'graphql-request';
import { useQuery, UseQueryResult } from 'react-query';
import { useAuth } from 'routes/Auth/AuthProvider';
import { graphqlConfig } from 'services/config/graphqlConfig';
import { AdminNearestPracticeTest } from './types';

export const useAdminNearestPracticeTest = (classId?: number) => {
  const { client } = graphqlConfig();
  const user = useAuth();

  const data: UseQueryResult<AdminNearestPracticeTest, Error> = useQuery<AdminNearestPracticeTest, Error>(['adminNearerstPracticeTest'], async () => client.request(
    gql`
    query AdminNearestTest($classId: Float!) {
      adminNearestTest(classId: $classId) {
        id
        name
        classId
        details
        status
        dueDate
        attachments {
          id
          attachment
          teacherAttachment
        }
        receivedMark {
          QuantitativeScore
          englishScore
          listening
          mathScore
          reading
          speaking
          totalScore
          verbalScore
          writing
        }
      }
    }
    `,
    {
      classId: classId || undefined
    },
  ).catch((error) => console.error(error)), { enabled: !!(user.user?.user.is_teacher || user.user?.user.is_admin) });
  return data;
};
